import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { tick } from "svelte";

var root = $.from_html(`<div><dt> </dt> <dd> </dd></div>`);
var root_1 = $.from_html(`<article class="slex-toolhost-message"><span class="slex-toolhost-message-role"> </span> <div class="slex-toolhost-message-bubble"><p> </p></div></article>`);
var root_2 = $.from_html(`<article class="slex-toolhost-message slex-toolhost-tool-turn slex-toolhost-active-turn" data-role="assistant"><span class="slex-toolhost-message-role"> </span> <div class="slex-toolhost-call" data-status="pending"><div class="slex-toolhost-call-mount"></div></div></article>`);
var root_3 = $.from_html(`<strong> </strong> <em>=</em>`, 1);
var root_4 = $.from_html(`<article class="slex-toolhost-message slex-toolhost-result-turn" data-role="assistant"><span class="slex-toolhost-message-role"> </span> <div class="slex-toolhost-result"><p><!> </p></div></article>`);
var root_5 = $.from_html(`<small> </small>`);
var root_6 = $.from_html(`<li><span></span> <p> </p></li>`);
var root_7 = $.from_html(`<li><div class="slex-toolhost-protocol-head"><span> </span> <!></div> <p class="slex-toolhost-protocol-summary"> </p> <details class="slex-toolhost-protocol-payload"><summary> </summary> <pre> </pre></details></li>`);
var root_8 = $.from_html(`<details class="slex-toolhost-protocol"><summary> </summary> <ol></ol></details>`);
var root_9 = $.from_html(`<section class="slex-toolhost-replay slex-toolhost-replay--scenario"><header class="slex-toolhost-replay-header"><div><p class="slex-toolhost-replay-eyebrow"> </p> <h2> </h2> <p> </p></div> <button class="slex-toolhost-replay-reset" type="button"> </button></header> <dl class="slex-toolhost-dialog-state"></dl> <section class="slex-toolhost-replay-panel"><div class="slex-toolhost-replay-transcript"></div></section> <details class="slex-toolhost-reference"><summary class="slex-toolhost-reference-summary"><span> </span> <strong> </strong> <!></summary> <div class="slex-toolhost-reference-body"><ol class="slex-toolhost-reference-flow"></ol> <pre><code> </code></pre></div></details> <!></section>`);

export default function ToolReplayShell($$anchor, $$props) {
	$.push($$props, true);

	let reference = $.prop($$props, 'reference', 19, () => ({ steps: [], code: "" })),
		statusItems = $.prop($$props, 'statusItems', 19, () => []),
		transcript = $.prop($$props, 'transcript', 19, () => []),
		protocolItems = $.prop($$props, 'protocolItems', 19, () => []);

	let transcriptEl = $.state(null);

	function attachPendingTool(node, item) {
		const cleanup = item.mountTool?.(node);

		if (typeof cleanup === "function") return { destroy: cleanup };
		if (cleanup && typeof cleanup.destroy === "function") return cleanup;

		return {};
	}

	function formatPayload(value) {
		if (typeof value === "string") return value;

		if (value && typeof value === "object" && typeof value.output === "string") {
			try {
				return JSON.stringify({ ...value, output: JSON.parse(value.output) }, null, 2);
			} catch {
				return JSON.stringify(value, null, 2);
			}
		}

		return JSON.stringify(value ?? {}, null, 2);
	}

	function previewText(value, max = 96) {
		const text = typeof value === "string" ? value : JSON.stringify(value ?? {});

		return text.length > max ? `${text.slice(0, max)}...` : text;
	}

	function protocolSummary(item) {
		const summaries = $$props.copy.protocolSummaries ?? {};

		if (item.type === "message/output_text") {
			return `${summaries.messageOutput ?? item.label}: ${previewText(item.body, 88)}`;
		}

		if (item.type === "response.output_item.added") {
			return `${summaries.functionCallAdded ?? "function_call received"}: ${item.body?.name ?? item.label}`;
		}

		if (item.type === "response.function_call_arguments.delta") {
			return `${summaries.argumentsDelta ?? "arguments fragment"} (${String(item.body ?? "").length} chars)`;
		}

		if (item.type === "response.function_call_arguments.done") {
			return summaries.argumentsDone ?? "arguments assembled";
		}

		if (item.type === "response.output_item.done") {
			return `${summaries.outputItemDone ?? "function_call complete"}: ${item.body?.name ?? item.label}`;
		}

		if (item.type === "toolhost.slex_expression") {
			return summaries.slexExpression ?? "ToolHost compiled the call into Slex components";
		}

		if (item.type === "function_call_output") {
			return summaries.functionCallOutput ?? "ToolHost returned user input to the agent";
		}

		return previewText(item.body);
	}

	$.user_effect(() => {
		transcript().length;

		void tick().then(() => {
			if ($.get(transcriptEl)) $.get(transcriptEl).scrollTop = $.get(transcriptEl).scrollHeight;
		});
	});

	var section = root_9();
	var header = $.child(section);
	var div = $.child(header);
	var p = $.child(div);
	var text_1 = $.child(p, true);

	$.reset(p);

	var h2 = $.sibling(p, 2);
	var text_2 = $.child(h2, true);

	$.reset(h2);

	var p_1 = $.sibling(h2, 2);
	var text_3 = $.child(p_1, true);

	$.reset(p_1);
	$.reset(div);

	var button = $.sibling(div, 2);
	var text_4 = $.child(button, true);

	$.reset(button);
	$.reset(header);

	var dl = $.sibling(header, 2);

	$.each(dl, 21, statusItems, (item) => item.label, ($$anchor, item) => {
		var div_1 = root();
		var dt = $.child(div_1);
		var text_5 = $.child(dt, true);

		$.reset(dt);

		var dd = $.sibling(dt, 2);
		var text_6 = $.child(dd, true);

		$.reset(dd);
		$.reset(div_1);

		$.template_effect(() => {
			$.set_text(text_5, $.get(item).label);
			$.set_text(text_6, $.get(item).value);
		});

		$.append($$anchor, div_1);
	});

	$.reset(dl);

	var section_1 = $.sibling(dl, 2);
	var div_2 = $.child(section_1);

	$.each(div_2, 21, transcript, (item) => item.id, ($$anchor, item) => {
		var fragment = $.comment();
		var node_1 = $.first_child(fragment);

		{
			var consequent = ($$anchor) => {
				var article = root_1();
				var span = $.child(article);
				var text_7 = $.child(span, true);

				$.reset(span);

				var div_3 = $.sibling(span, 2);
				var p_2 = $.child(div_3);
				var text_8 = $.child(p_2, true);

				$.reset(p_2);
				$.reset(div_3);
				$.reset(article);

				$.template_effect(() => {
					$.set_attribute(article, 'data-role', $.get(item).role);
					$.set_text(text_7, $.get(item).role === "user" ? $$props.copy.userLabel : $$props.copy.assistantLabel);
					$.set_text(text_8, $.get(item).text);
				});

				$.append($$anchor, article);
			};

			var consequent_1 = ($$anchor) => {
				var article_1 = root_2();
				var span_1 = $.child(article_1);
				var text_9 = $.child(span_1, true);

				$.reset(span_1);

				var div_4 = $.sibling(span_1, 2);
				var div_5 = $.child(div_4);

				$.action(div_5, ($$node, $$action_arg) => attachPendingTool?.($$node, $$action_arg), () => $.get(item));
				$.reset(div_4);
				$.reset(article_1);
				$.template_effect(() => $.set_text(text_9, $$props.copy.toolLabel));
				$.append($$anchor, article_1);
			};

			var consequent_3 = ($$anchor) => {
				var article_2 = root_4();
				var span_2 = $.child(article_2);
				var text_10 = $.child(span_2, true);

				$.reset(span_2);

				var div_6 = $.sibling(span_2, 2);
				var p_3 = $.child(div_6);
				var node_2 = $.child(p_3);

				{
					var consequent_2 = ($$anchor) => {
						var fragment_1 = root_3();
						var strong = $.first_child(fragment_1);
						var text_11 = $.child(strong, true);

						$.reset(strong);
						$.next(2);
						$.template_effect(() => $.set_text(text_11, $.get(item).title));
						$.append($$anchor, fragment_1);
					};

					$.if(node_2, ($$render) => {
						if ($.get(item).title) $$render(consequent_2);
					});
				}

				var text_12 = $.sibling(node_2);

				$.reset(p_3);
				$.reset(div_6);
				$.reset(article_2);

				$.template_effect(() => {
					$.set_text(text_10, $$props.copy.toolResultLabel || $$props.copy.toolLabel);
					$.set_attribute(div_6, 'data-status', $.get(item).status);
					$.set_text(text_12, ` ${$.get(item).summary ?? ''}`);
				});

				$.append($$anchor, article_2);
			};

			$.if(node_1, ($$render) => {
				if ($.get(item).kind === "message") $$render(consequent); else if ($.get(item).kind === "tool-call" && $.get(item).status === "pending") $$render(consequent_1, 1); else if ($.get(item).kind === "tool-output") $$render(consequent_3, 2);
			});
		}

		$.append($$anchor, fragment);
	});

	$.reset(div_2);
	$.bind_this(div_2, ($$value) => $.set(transcriptEl, $$value), () => $.get(transcriptEl));
	$.reset(section_1);

	var details = $.sibling(section_1, 2);
	var summary = $.child(details);
	var span_3 = $.child(summary);
	var text_13 = $.child(span_3, true);

	$.reset(span_3);

	var strong_1 = $.sibling(span_3, 2);
	var text_14 = $.child(strong_1, true);

	$.reset(strong_1);

	var node_3 = $.sibling(strong_1, 2);

	{
		var consequent_4 = ($$anchor) => {
			var small = root_5();
			var text_15 = $.child(small, true);

			$.reset(small);
			$.template_effect(() => $.set_text(text_15, $$props.copy.referenceDescription));
			$.append($$anchor, small);
		};

		$.if(node_3, ($$render) => {
			if ($$props.copy.referenceDescription) $$render(consequent_4);
		});
	}

	$.reset(summary);

	var div_7 = $.sibling(summary, 2);
	var ol = $.child(div_7);

	$.each(ol, 21, () => reference().steps, $.index, ($$anchor, step, index) => {
		var li = root_6();
		var span_4 = $.child(li);

		span_4.textContent = index + 1;

		var p_4 = $.sibling(span_4, 2);
		var text_16 = $.child(p_4, true);

		$.reset(p_4);
		$.reset(li);
		$.template_effect(() => $.set_text(text_16, $.get(step)));
		$.append($$anchor, li);
	});

	$.reset(ol);

	var pre = $.sibling(ol, 2);
	var code = $.child(pre);
	var text_17 = $.child(code, true);

	$.reset(code);
	$.reset(pre);
	$.reset(div_7);
	$.reset(details);

	var node_4 = $.sibling(details, 2);

	{
		var consequent_6 = ($$anchor) => {
			var details_1 = root_8();
			var summary_1 = $.child(details_1);
			var text_18 = $.child(summary_1, true);

			$.reset(summary_1);

			var ol_1 = $.sibling(summary_1, 2);

			$.each(ol_1, 21, protocolItems, (item) => item.id, ($$anchor, item) => {
				var li_1 = root_7();
				var div_8 = $.child(li_1);
				var span_5 = $.child(div_8);
				var text_19 = $.child(span_5, true);

				$.reset(span_5);

				var node_5 = $.sibling(span_5, 2);

				{
					var consequent_5 = ($$anchor) => {
						var small_1 = root_5();
						var text_20 = $.child(small_1, true);

						$.reset(small_1);
						$.template_effect(() => $.set_text(text_20, $$props.copy.generatedLabel));
						$.append($$anchor, small_1);
					};

					$.if(node_5, ($$render) => {
						if ($.get(item).generated) $$render(consequent_5);
					});
				}

				$.reset(div_8);

				var p_5 = $.sibling(div_8, 2);
				var text_21 = $.child(p_5, true);

				$.reset(p_5);

				var details_2 = $.sibling(p_5, 2);
				var summary_2 = $.child(details_2);
				var text_22 = $.child(summary_2, true);

				$.reset(summary_2);

				var pre_1 = $.sibling(summary_2, 2);
				var text_23 = $.child(pre_1, true);

				$.reset(pre_1);
				$.reset(details_2);
				$.reset(li_1);

				$.template_effect(
					($0, $1) => {
						$.set_attribute(li_1, 'data-generated', $.get(item).generated ? "true" : "false");
						$.set_text(text_19, $.get(item).type);
						$.set_text(text_21, $0);
						$.set_text(text_22, $$props.copy.rawJsonLabel ?? "Raw JSON");
						$.set_text(text_23, $1);
					},
					[
						() => protocolSummary($.get(item)),
						() => formatPayload($.get(item).raw ?? $.get(item).body)
					]
				);

				$.append($$anchor, li_1);
			});

			$.reset(ol_1);
			$.reset(details_1);

			$.template_effect(() => {
				$.set_attribute(details_1, 'aria-label', $$props.copy.eventDetailsLabel ?? $$props.copy.protocolLabel);
				$.set_text(text_18, $$props.copy.eventDetailsLabel ?? $$props.copy.protocolLabel);
			});

			$.append($$anchor, details_1);
		};

		$.if(node_4, ($$render) => {
			if (protocolItems().length) $$render(consequent_6);
		});
	}

	$.reset(section);

	$.template_effect(() => {
		$.set_attribute(section, 'aria-label', $$props.copy.title);
		$.set_text(text_1, $$props.copy.eyebrow);
		$.set_text(text_2, $$props.copy.title);
		$.set_text(text_3, $$props.copy.subtitle);
		$.set_text(text_4, $$props.copy.restartLabel);
		$.set_attribute(dl, 'aria-label', $$props.copy.decisionLabel);
		$.set_attribute(section_1, 'aria-label', $$props.copy.transcriptLabel);
		$.set_attribute(details, 'aria-label', $$props.copy.referenceLabel ?? $$props.copy.protocolLabel);
		$.set_text(text_13, $$props.copy.referenceEyebrow ?? "SlexKit ToolHost");
		$.set_text(text_14, $$props.copy.referenceTitle ?? $$props.copy.protocolLabel);
		$.set_text(text_17, reference().code);
	});

	$.delegated('click', button, function (...$$args) {
		$$props.onRestart?.apply(this, $$args);
	});

	$.append($$anchor, section);
	$.pop();
}

$.delegate(['click']);